module.exports = __webpack_public_path__ + "static/img/btn-back.ca3676a0.png";